import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const add = require("../../../../../../assets/icons/add.svg");
const filter = require("../../../../../../assets/icons/filter.svg");

const styles = makeStyles(() => ({
  "@global": {
    body: {
      '& [class^="makeStyles-menuHeader"]': {
        "& > :last-child": {
          backgroundColor: "#ffffff !important",
          "& .MuiButton-label": {
            backgroundColor: "#ffffff !important",
            visibility: "visible", // Change to 'visible' to ensure text is displayed
            "&::before": {
              content: '"Go"',
              color: "#0055A4",
              position: "absolute",
              top: 0,
              left: "10",
              fontSize: "18px",
              lineHeight: "1",
              padding: "8px",
            },
          },
        },
        "& .MuiButton-label": { Color: "#ffffff !important" },
      },
      "& .MuiButton-label": { Color: "#ffffff !important" },
    },
  },
  statusBadge: {
    background: "#FEF3F2 !important",
    border: "1px solid #E0E2E7",
    padding: "5px 10px",
    borderRadius: 20,
    height: 32,
    fontWeight: 600,
    fontSize: 10,
    lineHeight: "20px",
    color: "#D92D20 !important",
  },

  statusBadgeActive: {
    background: "#ECFDF3 !important",
    border: "1px solid #ECFDF3",
    color: "#039855 !important",
  },
  button: {
    cursor: "pointer",
  },
  changeStatusButton: {
    whiteSpace: "nowrap",
    "& span > div": {
      display: "flex",
      alignItems: "center",
    },
  },
  buttonColor: {
    '& [class^="makeStyles-leftItem"]': {
      "& .MuiButtonBase-root": {
        backgroundColor: "white !important",
        border: "2px solid #E4E7Ec !important",
      },
      "& .MuiButton-startIcon": {
        visibility: "hidden",
        "& >svg": {
          // color: '#475467 !important',
        },
      },
      "& .MuiButton-label": {
        position: "relative",
      },
      '& [class^="makeStyles-textButton"]': {
        color: "#475467",
        "&::before": {
          content: '" "',
          position: "absolute",
          top: 0,
          left: 0,
          color: "#000",
          fontSize: "24px",
          lineHeight: "1",
          padding: "8px",
          backgroundImage: `url(${filter})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        },
        "& .makeStyles-textButton": {
          color: "#475467 !important",
        },
      },
    },
    '& [class^="makeStyles-topPanel"]': {
      "& >:last-child": {
        "& .MuiButtonBase-root": {
          backgroundColor: "#0055A4 !important",
        },
        "& .MuiButton-startIcon": {
          visibility: "hidden",
        },
        "& .MuiButton-label": {
          position: "relative",
          "&::before": {
            content: '" "',
            position: "absolute",
            top: "2px",
            left: 0,
            color: "#000",
            fontSize: "24px",
            lineHeight: "1",
            padding: "8px",
            backgroundImage: `url(${add})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
          },
        },
        '& [class^="makeStyles-textButton"]': {
          color: "#475467",
          "& .makeStyles-textButton": {
            color: "#475467 !important",
          },
        },
      },
    },
    '& [class^="makeStyles-rightItem"]': {
      "& >:MuiButton-startIcon": {
        visibility: "hidden",
      },
    },

    '& [class^="makeStyles-menuHeader"]': {
      "& .MuiButtonBase-root": { backgroundColor: "#000000 !important" },

      "& >:last-child": {
        backgroundColor: "#000000 !important",

        "& .makeStyles-button": {
          backgroundColor: "#000000 !important",
          Color: "#000000 !important",
        },
      },
    },
  },
  newRecordText: {
    whiteSpace: "nowrap",
  },
  status: {
    width: "fit-content",
  },
  circularProgress: {
    color: colors.gray500,
  },
}));

export default styles;
